import { List } from 'immutable';
import { comparableTransactionConstants } from '../constants';

export function comparable_transactions(state = {}, action) {
  switch (action.type) {
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case comparableTransactionConstants.COMPARABLE_TRANSACTION_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const comparableTransactionIndex = state.items.findIndex(val => val.id == action.response.id);

      if (comparableTransactionIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(comparableTransactionIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case comparableTransactionConstants.COMPARABLE_TRANSACTION_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_DELETE_SUCCESS: {
      const { comparableTransactionId } = action;

      if (!state.items) {
        return state;
      }

      const comparableTransactionIndex = state.items.findIndex(
        val => val.id == comparableTransactionId
      );

      if (comparableTransactionIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(comparableTransactionIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case comparableTransactionConstants.COMPARABLE_TRANSACTION_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
